<template>
    <ai-grid-ro-wrapper
        class="locked-users-grid"
        ref="gridRef"
        :meta="meta"
        :dataSource="props.dataSource.data.users"
        :toRemoveToolbarItemsNames="toRemoveToolbarItemsNames"
        :show-grid-footer="true"
        :hasnt-route="true"
    />
</template>

<script setup>
import { ref } from 'vue';
import AiGridRoWrapper from '@/components/wrappers/ai-grid-ro-wrapper.vue';

const gridRef = ref();

const props = defineProps({
    dataSource: {
        type: Object,
        default: () => {
        },
    },
});

const toRemoveToolbarItemsNames = ['refresh', 'choice'];

const meta = {
    keyExpr: 'id',
    autoLoadData: false,
    columns: [
        {
            caption: 'ID',
            dataField: 'id',
            dataType: 'number',
            visible: false,
        },
        {
            caption: 'Пользователь',
            dataField: 'login',
            dataType: 'string',
            visible: true,
        },
        {
            caption: 'ФИО',
            dataField: 'fio',
            dataType: 'string',
            visible: true,
        },
    ],
};
</script>

<style lang="scss">
.locked-users-grid {
    background: #FFFFFF;
    min-height: 400px;
}
</style>
